import { createSlice } from "@reduxjs/toolkit";
import { loginApi } from "../api/api";

const initialState = {
  loginLoading: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loginApi.pending, (state) => {
      state.loginLoading = true;
    });
    builder.addCase(loginApi.fulfilled, (state) => {
      state.loginLoading = false;
    });
    builder.addCase(loginApi.rejected, (state) => {
      state.loginLoading = false;
    });
  },
});

export default authSlice.reducer;
